var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlvotechMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#222222;}\n\t.st1{fill:#F69D25;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#F69D25;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#222222;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pipline"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "biosimilar"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "employees"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "network"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "generic-projects"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "manufacturing-centers"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "key-growth"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "molecule"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "green"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "map"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color_8_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "color_9_",
    className: "st2",
    d: "M276.4,71.8c-24.3,0-44.1,19.8-44.1,44.1c0,24.3,19.8,44.1,44.1,44.1 c24.3,0,44.1-19.8,44.1-44.1C320.5,91.5,300.7,71.8,276.4,71.8z M276.4,142.2c-14.6,0-26.4-11.8-26.4-26.4 c0-14.5,11.8-26.4,26.4-26.4s26.4,11.8,26.4,26.4C302.8,130.4,290.9,142.2,276.4,142.2z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "neutral_10_",
    className: "st3",
    d: "M465.6,84.2c-2.7-1.6-6-1.6-8.7-0.2l-93.8,51.1c0.8-5.8,1.3-11.5,1.3-17 c0-48.5-39.5-87.9-88-87.9c-47.4,0-86.2,37.7-87.9,84.6l-43.9,19.9L42.8,83.9c-2.7-1.4-6-1.2-8.6,0.4c-2.6,1.6-4.2,4.4-4.2,7.5 v316.5c0,3.3,1.9,6.4,4.9,7.9l105.6,52.7c2.5,1.2,5.4,1.2,7.9,0L250.2,418l110.5,51c1.2,0.5,2.4,0.8,3.7,0.8c1.5,0,2.9-0.4,4.2-1.1 l96.8-52.7c2.8-1.5,4.6-4.5,4.6-7.7V91.8C469.9,88.6,468.3,85.8,465.6,84.2z M276.4,48.3c38.8,0,70.4,31.6,70.4,70.3 c0,7.5-0.9,15.2-2.6,23.1c0,0,0,0.1,0,0.1c-10.7,51.2-51.6,108.4-67.8,129.7c-18.5-23.9-68.8-93.7-70.3-150.3c0-0.3,0-0.5,0-0.8 c0-0.6,0-1.2,0-1.8C206,79.9,237.6,48.3,276.4,48.3z M452.3,403L364,451.2l-110.4-50.9c-2.4-1.1-5.2-1.1-7.6,0.1l-101.6,50.8 l-96.8-48.4V106l92.8,46.4c2.4,1.2,5.2,1.2,7.6,0.1l41.4-18.8c9.2,72.4,77.1,153.5,80.2,157.1c1.7,2,4.1,3.1,6.7,3.1h0 c2.6,0,5.1-1.2,6.7-3.2c2.8-3.4,59.3-72,76.4-138l3.8,0.5c1.9,0.2,3.7-0.1,5.3-1l83.8-45.7V403z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "playground"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "microscope"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "basket"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "hand-pill"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "cosmetics"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "medical"
  })));
}

export default SvgAlvotechMap;